<template>
  <span v-clickoutside="handleOutside">
    <el-date-picker :class="{'error-border':error}" ref="dataPicker" size="small" popper-class='map-date-picker' :clearable="false" v-model="dateValue" align="center" type="daterange"
      placeholder="选择日期" range-separator="~" start-placeholder="开始日期" :default-value="new Date().setMonth(new Date().getMonth() - 1)" end-placeholder="结束日期" format="yyyy / MM / dd "
      value-format="timestamp" @change='change' @blur="dateBlur" @focus="multiFocus" />
    <!--         :picker-options="constraint.enableSelectAfter ? {} :pickerOptions" -->
    <!-- <i v-if="clearShow" class="clear-icon el-icon-error" @click="clearAllChecked"></i>
      <i v-if="!clearShow" class="el-icon-caret-bottom"></i> -->
  </span>
</template>

<script>
import Clickoutside from '@/utils/clickoutside'
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import last from "lodash/last";
import { parseTime } from "@/base/global";

export default {
  props: ["value", "options", "dateName", "placeholder", "constraint", 'error'],
  data() {
    return {
      clearShow: false, //快捷删除图标
      dateValue: [], //多选选中的值
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < 0;
        },
      }
    };
  },
  directives: { Clickoutside },

  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        // todo 优化
        if (newVal && newVal[0] && newVal[0].includes('-')) {
          this.dateValue = newVal.map(e => new Date(e))
        } else {
          this.dateValue = null
        }
      }
    }
  },

  methods: {
    validator() {
      return this.dateValue && this.dateValue.length > 0 ? '' : '请填选必填项';
    },

    dateBlur() {
      this.$emit("input-cv-focus", false);
      this.$emit("validateNode");
    },

    handleOutside() {
      this.clearShow = false;
    },

    multiFocus() {
      // this.inputFocus(true);
      this.clearShow = isArray(this.dateValue) && this.dateValue.length > 0;
      this.$emit('input-cv-focus', true);
    },

    change(values) {
      if (values) {
        // const arr=[];
        // const str=values[0]+'-'+(values[1]?values[1]+24 * 60 * 60 * 1000 - 1:'');
        // arr[0]=str;
        this.$emit('change', [parseTime(values[0], '{y}-{m}-{d}'), parseTime(values[1], '{y}-{m}-{d}')])


      } else {
        this.$emit('change', values)
      }
    },
    clearAllChecked() {
      this.clearShow = false;
      this.$emit("change", []);
    }
  }
}
</script>

<style lang='scss' scoped>
//  .el-icon-caret-bottom {
//     right: 8px;
//     position: absolute;
//     font-size: 14px;
//     top: 50%;
//     color: #d9d9d9;
//     transform: translateY(-50%);
//   }
/deep/ .el-date-editor .el-range-input {
  box-shadow: none !important;
}

.el-icon-error {
  right: 8px;
  position: absolute;
  font-size: 14px;
  top: 50%;
  color: #d9d9d9;
  transform: translateY(-50%);
}
::v-deep {
    .el-range-editor--small .el-range-separator{
       line-height: 36px;
   }
   .el-range-editor--small.el-input__inner{
     line-height: 36px;
     height: 36px;
   }
   
}

</style>
<style lang='scss'>
   .map-date-picker{
       .el-date-table td.today span{
        font-weight: 500;
        color: #343951;
        font-size: 14px;
        border-bottom: 2px solid #5088FF !important;
      }
       .el-date-table th{
          border-bottom: none;
          font-weight: 400;
          color: #8C8C8C;
          font-size: 14px;
        }
        .el-date-range-picker__content .el-date-range-picker__header div{
          font-weight: bold;
        font-size: 14px;
      }
      .el-date-table td.in-range div{
        background-color: #F7F7F7;
      }
   }
</style>